export default "__VITE_ASSET__zF4eT__R__"